export const convertWidgetData = (widget) => widget;
